<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account/memberList")
          i.fa.fa-users
          span.ml-1 {{ $t("ui.member_list") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-2(v-if="filterBy == 'vip'")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.vip') }}
                    VipLookup(
                      ref="vip_id"
                      size="sm"
                      required
                      type="array"
                      :dirty="$v.vip_id.$dirty"
                      :error="$v.vip_id.$error"
                      v-model.trim.lazy="$v.vip_id.$model"
                      :disabled="loading"
                    )
                  ValidateResult(:value="$v.vip_id" :name="$tc('ui.vip')")
                template(v-else)
                  div.col-md-2.mb-1
                    b-input-group(size="sm").mb-1
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.search_by_member') }}
                      b-input-group-text(slot="append")
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="searchByMember" @input="resetInput()")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                  div.col-md-3.mb-1(v-if="searchByMember == true")
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getMemberList(true)")
                div.row.col-md-7.mb-1
                  div(width="80%" v-if="searchByMember == false")
                    DateRangePicker(:value="dateRange" @update="getData").mr-3
                  div(width="80%" v-if="searchByMember == true").mr-3
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="account_id") {{ $t("ui.account_id") }}
                      b-form-radio(value="full_name") {{ $t("ui.full_name") }}
                      b-form-radio(value="contact_phone") {{ $t("ui.contact_phone") }}
                      b-form-radio(value="signup_ip") {{ $t("ui.signup_ip") }}
                      b-form-radio(value="referral_code") {{ $t("ui.referral_code") }}
                      b-form-radio(value="vip") {{ $t("ui.vip") }}
                  div(width="20%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getMemberList(true)"
                      variant="success"
                      size="sm"
                      )
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width="2%")
                        span #
                      th.sticky-position.sortable(width="7%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="6%" @click="sortOrder('full_name')")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name')")
                      th.sticky-position.sortable(width="5%" @click="sortOrder('contact_phone')")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                        i(:class="changeSortKey('contact_phone')")
                      th.sticky-position.sortable(width="6%" @click="sortOrder('contact_email')")
                        span(:title="$t('ui.contact_email')") {{ $t("ui.contact_email") }}
                        i(:class="changeSortKey('contact_email')")
                      th.sticky-position.sortable(width="5%" @click="sortOrder('vip_id')")
                        span(:title="$t('ui.vip_name')") {{ $t("ui.vip_name") }}
                        i(:class="changeSortKey('vip_id')")
                      th.sticky-position.sortable(width="6%" @click="sortOrder('signup_ip')")
                        span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                        i(:class="changeSortKey('signup_ip')")
                      th.sticky-position(width="5%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position(width="7%")
                        span(:title="$t('ui.balance')") {{ $t("ui.balance") }}
                      th.sticky-position(width="6%")
                        span(:title="$t('ui.ftd_amount')") {{ $t("ui.ftd_amount") }}
                      th.sticky-position(width="5%")
                        span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                      //- th.sticky-position(width="5%")
                      //-   span(:title="$t('ui.referrer_code')") {{ $t("ui.referrer_code") }}
                      th.sticky-position(width="5%")
                        span(:title="$t('ui.referral_code')") {{ $t("ui.referral_code") }}
                      th.sticky-position(width="4%")
                        span(:title="$t('ui.downline')") {{ $t("ui.downline") }}
                      th.sticky-position(width="5%")
                        span(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
                      th.sticky-position(width="4%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      //- th.text-center.sticky-position.sticky-toggle(width="6%")
                      //-   span(:title="$t('ui.referral_status')") {{ $t("ui.referral_status") }}
                      //- th.text-center.sticky-position(width="20%")
                      //-   span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position.sortable(width="7%" @click="sortOrder('created_date')")
                        span {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="memberList.length == 0")
                      td(colspan="16").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in memberList" :class="$helpers.rowClass(item)")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span.font-weight-bold(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.contact_email") {{ item.contact_email }}
                      td
                        span(:title="item.vip_name") {{ item.vip_name }}
                      td
                        span(:title="item.signup_ip") {{ item.signup_ip }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(:title="$n(item.game_balance, 'currency')") {{ $n(item.game_balance, 'currency') }}
                        span(:class="{'text-danger': item.outstanding_balance < 0  }" v-if="item.outstanding_balance != 0 && item.outstanding_balance != null" :title="$n(item.outstanding_balance, 'currency')") ({{ $n(item.outstanding_balance, 'currency') }})
                        //- span.font-weight-bold(:class="{'text-danger': item.outstanding_balance < 0  }" v-if="item.outstanding_balance != 0 && item.outstanding_balance != null" :title="$n(item.outstanding_balance, 'currency')")
                        //-   b-link.clickable(href="javascript:void(0);" @click="onClearOutstanding(item)") ({{ $n(item.outstanding_balance, 'currency') }})
                      td
                        span(:title="item.ftd_amount != null ? $n(item.ftd_amount, 'currency') : item.ftd_amount") {{ item.ftd_amount != null ? $n(item.ftd_amount, 'currency') : item.ftd_amount }}
                      td
                        span(:title="item.referrer_id") {{ item.referrer_id }}
                      //- td
                      //-   span(:title="item.referrer_code") {{ item.referrer_code }}
                      td
                        span(:title="item.referral_code") {{ item.referral_code }}
                      td
                        //- span.font-weight-bold(v-if="item.referee_count_confirm == 0" :title="$n(item.referee_count_confirm, 'integer')") {{ $n(item.referee_count_confirm, 'integer') }}
                        //- span.font-weight-bold(v-if="item.referee_count_confirm != 0")
                        //-   b-link(href="javascript:void(0);" @click="redirectToRL(item)" :title="$n(item.referee_count_confirm, 'integer')") {{ $n(item.referee_count_confirm, 'integer') }}
                        span.font-weight-bold(:title="$n(item.referee_count_confirm, 'integer')") {{ $n(item.referee_count_confirm, 'integer') }}
                      td
                        span(:title="item.affiliate_id") {{ item.affiliate_id }}
                      td
                        span(:title="item.status") {{ item.status }}
                        //- span(v-if="item.status.toUpperCase() == 'FREEZE' || item.status.toUpperCase() == 'BLOCK'" :title="item.status") {{ item.status }}
                        //- select(@change="changedMemberStatus(item, $event)" :value="item.status" v-else)
                        //-   option(value="ACTIVE") {{ $t("ui.active") }}
                        //-   //- option(value="BLOCK" :disabled="item.status.toUpperCase() != 'BLOCK'") {{ $t("ui.block") }}
                        //-   option(value="CLOSE") {{ $t("ui.close") }}
                      //- td
                      //-   div.d-flex.justify-content-center.align-items-center
                      //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      //-       input.switch-input(type="checkbox" v-model="item.referral_status" @change="changedReferralStatus(item, $event)")
                      //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
                      //- td.actions
                      //-   span
                      //-     a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                      //-   span
                      //-     a.fa.fa-lock.text-warning(href="javascript:void(0)" @click="onResetPasswordMember(item)" :title="$t('ui.reset_password')")
                      //-   span
                      //-     a.fa.fa-user.text-success(href="javascript:void(0)" @click="onUpdateMemberProfile(item)" :title="$t('ui.update_member_profile')")
                      //-   span
                      //-     a.fas.fa-gamepad.text-secondary(href="javascript:void(0)" @click="onUpdateMemberBetLimit(item)" :title="$t('ui.update_member_bet_limit')")
                      //-   span
                      //-     a.fa.fa-sliders-h.text-secondary(href="javascript:void(0)" @click="onAdjust(item)" :title="$t('ui.adjust_balance')")
                      //-   span
                      //-     a.fa.fa-gift.text-warning(href="javascript:void(0)" @click="onPromoMemberAssign(item)" :title="$t('ui.add_promo')")
                      //-   span
                      //-     a.fa.fa-money-bill-alt.text-info(href="javascript:void(0)" @click="onBonusIssue(item)" :title="$t('ui.bonus_issue')")
                      //-   span
                      //-     a.fas.fa-crown.text-warning(href="javascript:void(0)" @click="onUpdateVip(item)" :title="$t('ui.update_vip')")
                      //-   span
                      //-     a.fas.fa-mobile-alt.text-secondary(href="javascript:void(0)" @click="onGetTac(item)" :title="$t('ui.get_tac')")
                      //-   span
                      //-     a.fas.fa-building.text-info(href="javascript:void(0)" @click="onGetBankTac(item)" :title="$t('ui.get_bank_tac')")
                      //-   span
                      //-     a.fas.fa-envelope.text-success(href="javascript:void(0)" @click="onGetInbox(item)" :title="$t('ui.get_inbox')")
                      //-   span
                      //-     a.fas.fa-piggy-bank.text-info(href="javascript:void(0)" @click="onGetRebate(item)" :title="$t('ui.get_rebate')")
                      //-   span
                      //-     a.fas.fa-gamepad.text-info(href="javascript:void(0)" @click="onCheckMemberFreeSpin(item)" :title="$t('ui.check_free_spin')")
                      //-   span(v-if="item.status.toUpperCase() == 'ACTIVE'")
                      //-     a.fas.fa-list-alt.text-danger(href="javascript:void(0)" @click="onRaiseDepositTicket(item)" :title="$t('ui.raise_deposit_ticket')")
                      //-   span
                      //-     a.fa.fa-credit-card.text-warning(href="javascript:void(0)" @click="onPromoSignupAssign(item)" :title="$t('ui.free_credit')")
                      //-   span(v-if="item.status.toUpperCase() == 'BLOCK'")
                      //-     a.fa.fa-unlock.text-danger(href="javascript:void(0)" @click="onUnblock(item)" :title="$t('ui.unblock')")
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    editmember(ref="editmember" :item="editSelectedMember" @clicked="afterEditMember" @failed="handleFailed")
    adjustmember(ref="adjustmember" :item="editSelectedMember" @clicked="afterAdjustMember" @failed="handleFailed")
    resetpasswordmember(ref="resetpasswordmember" :item="editSelectedMember" @clicked="afterResetPasswordMember" @failed="handleFailed")
    gettac(ref="gettac" :item="editSelectedMember" @failed="handleFailed")
    getbanktac(ref="getbanktac" :item="editSelectedMember" @failed="handleFailed")
    raisedepositticket(ref="raisedepositticket" :item="editSelectedMember" @clicked="afterRaiseDepositTicket" @failed="handleFailed")
    bonusissue(ref="bonusissue" :item="editSelectedMember" @clicked="afterIssueBonus" @failed="handleFailed")
    promomemberassign(ref="promomemberassign" :item="editSelectedMember" @clicked="afterPromoMemberAssign" @failed="handleFailed")
    updatevip(ref="updatevip" :item="editSelectedMember" @clicked="afterUpdateVip" @failed="handleFailed")
    updatememberprofile(ref="updatememberprofile" :item="editSelectedMember" @clicked="afterUpdateMemberProfile" @failed="handleFailed")
    updatememberbetlimit(ref="updatememberbetlimit" :item="editSelectedMember" @clicked="afterUpdateMemberBetLimit" @failed="handleFailed")
    getinboxlist(ref="getinboxlist" :item="editSelectedMember" @failed="handleFailed")
    membersummary(ref="membersummary" :item="editSelectedMember" @failed="handleFailed")
    getrebate(ref="getrebate" :item="editSelectedMember" @failed="handleFailed")
    checkmemberfreespin(ref="checkmemberfreespin" :item="editSelectedMember" @failed="handleFailed")
    clearoutstanding(ref="clearoutstanding" :item="editSelectedMember" @clicked="afterClearOutstanding" @failed="handleFailed")
    memberdetails(ref="memberdetails" :memberId="editSelectedMemberId" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editmember from "@/components/member/editMember.vue";
import adjustmember from "@/components/member/adjustMember.vue";
import resetpasswordmember from "@/components/member/resetPasswordMember.vue";
import raisedepositticket from "@/components/member/raiseDepositTicket.vue";
import gettac from "@/components/member/getTac.vue";
import getbanktac from "@/components/member/getBankTac.vue";
import bonusissue from "@/components/member/bonusIssue.vue";
import promomemberassign from "@/components/member/promoMemberAssign.vue";
import updatevip from "@/components/member/updateVip.vue";
import updatememberprofile from "@/components/member/updateMemberProfile.vue";
import updatememberbetlimit from "@/components/member/updateMemberBetLimit.vue";
import getinboxlist from "@/components/member/getInboxList.vue";
import membersummary from "@/components/member/memberSummary.vue";
import getrebate from "@/components/member/getRebate.vue";
import checkmemberfreespin from "@/components/member/checkMemberFreeSpin.vue";
import clearoutstanding from "@/components/member/clearOutstanding.vue";
import {resizeColumn1} from '@/main';
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import memberdetails from "@/components/member/memberDetails.vue";
import VipLookup from "@/library/VipLookup";
import ValidateResult from "@/library/ValidateResult";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editmember,
    adjustmember,
    resetpasswordmember,
    gettac,
    getbanktac,
    raisedepositticket,
    bonusissue,
    promomemberassign,
    updatevip,
    updatememberprofile,
    updatememberbetlimit,
    getinboxlist,
    membersummary,
    getrebate,
    checkmemberfreespin,
    clearoutstanding,
    DateRangePicker,
    memberdetails,
    VipLookup,
    ValidateResult
  },
  data: () => ({
    loading: false,
    memberList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedMember: null,
    editSelectedMemberId: "",
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id",
    searchByMember: true,
    dateRange: {
      startDate: null,
      endDate: null
    },
    vip_id: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    this.getMemberList(true);
    resizeColumn1();
  },
  validations: {
    vip_id: {
      required: requiredIf(function () {
        return ['vip'].includes(this.filterBy);
      })
    },
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getMemberList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    resetInput() {
      this.memberList = [];
      this.totalRow = 0;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.search = "";
      this.filterBy = "account_id";
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getMemberList(true);
    },
    redirectToRL: function(item) {
      var json = { referral_code: item.referral_code };
      this.$store.dispatch("user/setRefereeListParam", json);
      this.$router.push("/report/refereeList");
    },
    onPromoSignupAssign: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.free_credit"),
          text: this.$t("message.assign_free_credit_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPromoSignupAssign(item);
          }
        });
    },
    confirmPromoSignupAssign: function(item) {
      let url = config.promotionSignupAssignUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMemberList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedReferralStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_referral_status_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmReferralStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.referral_status = !item.referral_status;
          }
        });
    },
    confirmReferralStatus: function(item, status) {
      let url = config.memberStatusUpdateReferralUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getMemberList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(e) {
      this.editSelectedMember = e;
      this.$refs.editmember.$refs.editMember.show();
    },
    onAdjust(e) {
      this.editSelectedMember = e;
      this.$refs.adjustmember.$refs.adjustMember.show();
    },
    onResetPasswordMember(e) {
      this.editSelectedMember = e;
      this.$refs.resetpasswordmember.$refs.resetPasswordMember.show();
    },
    onGetTac(e) {
      this.editSelectedMember = e;
      this.$refs.gettac.$refs.getTac.show();
    },
    onGetBankTac(e) {
      this.editSelectedMember = e;
      this.$refs.getbanktac.$refs.getBankTac.show();
    },
    onRaiseDepositTicket(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticket.$refs.raiseDepositTicket.show();
    },
    onBonusIssue(e) {
      this.editSelectedMember = e;
      this.$refs.bonusissue.$refs.bonusIssue.show();
    },
    onPromoMemberAssign(e) {
      this.editSelectedMember = e;
      this.$refs.promomemberassign.$refs.promoMemberAssign.show();
    },
    onUpdateVip(e) {
      this.editSelectedMember = e;
      this.$refs.updatevip.$refs.updateVip.show();
    },
    onUpdateMemberProfile(e) {
      this.editSelectedMember = e;
      this.$refs.updatememberprofile.$refs.updateMemberProfile.show();
    },
    onUpdateMemberBetLimit(e) {
      this.editSelectedMember = e;
      this.$refs.updatememberbetlimit.$refs.updateMemberBetLimit.show();
    },
    onGetInbox(e) {
      this.editSelectedMember = e;
      this.$refs.getinboxlist.$refs.getInboxList.show();
    },
    onGetRebate(e) {
      this.editSelectedMember = e;
      this.$refs.getrebate.$refs.getRebate.show();
    },
    onInfo(e) {
      this.editSelectedMemberId = e.account_id;
      // this.$refs.membersummary.$refs.memberSummary.show();
      this.$refs.memberdetails.$refs.memberDetails.show();
    },
    onCheckMemberFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.checkmemberfreespin.$refs.checkMemberFreeSpin.show();
    },
    onClearOutstanding(e) {
      this.editSelectedMember = e;
      this.$refs.clearoutstanding.$refs.clearOutstanding.show();
    },
    checkMemberSearchCriteria: function () {
      if (this.search.trim() != '') {
        if (this.filterBy == "full_name" && this.search.trim().length < 3) {
          return false;
        }

        if (this.filterBy == "account_id" && this.search.trim().length < 3) {
          return false;
        }
      }

      return true;
    },
    getMemberList: function(isSearch) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.checkMemberSearchCriteria()) {
          let url = config.memberListUrl();

          if (isSearch) this.currentPage = 1;

          var json = {
            action_by: this.$store.getters.loginId,
            auth_token: this.$store.getters.sessionToken,
            account_id: this.$store.getters.accountId,
            sort_key: this.sortKey,
            sort_type: this.sortType,
            page_number: this.currentPage,
            page_size: this.getPageSize,
            vip_id: this.filterBy == 'vip' ? this.vip_id : null
          };

          if (this.searchByMember == true) {
            if (this.search.trim() != '') {
              if (this.filterBy == "account_id") {
                json.member_id = this.search.trim();
              } else if (this.filterBy == "full_name") {
                json.full_name = this.search.trim();
              } else if (this.filterBy == "contact_phone") {
                json.contact_phone = this.search.trim();
              } else if (this.filterBy == "signup_ip") {
                json.signup_ip = this.search.trim();
              } else if (this.filterBy == "referral_code") {
                json.referral_code = this.search.trim();
              }
            }
          }
          else {
            json.start_date = this.dateRange.startDate;
            json.end_date = this.dateRange.endDate;
          }

          this.loading = true;
          this.$http.post(url, json).then(
            function(response) {
              this.loading = false;
              // Success
              try {
                if (response) {
                  this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                  this.feedback.status = response.data.statusdesc;
                  if (this.feedback.success == true) {
                    this.memberList = response.data.dt;
                    this.totalRow = this.memberList.length > 0 ? this.memberList[0].totalrows : 0;
                  } else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            },
            function(response) {
              this.loading = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          );
        }
        else {
          this.totalRow = 0;
          this.memberList = [];
          if (this.filterBy == "full_name")
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.fullNameMinThreeChar"), "error");
          else if (this.filterBy == "account_id")
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.accountIdMinThreeChar"), "error");
        }
      }
    },
    onUnblock: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_member_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblock(item);
          }
        });
    },
    confirmUnblock: function(item) {
      let url = config.memberUnblockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = "ACTIVE";
                this.$helpers.showDialog(this.$t("ui.unblock_member"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedMemberStatus: function(member, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_member_status_confirm", { name: member.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMemberStatus(member, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = member.status;
          }
        });
    },
    confirmMemberStatus: function(member, status) {
      let url = config.memberStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: member.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                member.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterResetPasswordMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterAdjustMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_member"), this.$t("message.success"), "success");
    },
    afterEditMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_member"), this.$t("message.success"), "success");
    },
    afterRaiseDepositTicket: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket"), this.$t("message.success"), "success");
    },
    afterIssueBonus: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.bonus_issue"), this.$t("message.success"), "success");
    },
    afterPromoMemberAssign: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.promo_member_assign"), this.$t("message.success"), "success");
    },
    afterUpdateVip: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.update_vip"), this.$t("message.success"), "success");
    },
    afterUpdateMemberProfile: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.update_member_profile"), this.$t("message.success"), "success");
    },
    afterUpdateMemberBetLimit: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.update_member_bet_limit"), this.$t("message.success"), "success");
    },
    afterClearOutstanding: function(amt) {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.clear_outstanding"), this.$t("message.successful_clear_outstanding", { amt: this.$n(amt, 'currency') }), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getMemberList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
